
import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface GenerateContentParams {
  type: 'description' | 'tags' | 'blog' | 'custom';
  gameData?: any;
  prompt?: string;
}

export const useAIContentGeneration = () => {
  const generateContentMutation = useMutation({
    mutationFn: async ({ type, gameData, prompt }: GenerateContentParams) => {
      const { data, error } = await supabase.functions.invoke('generate-content', {
        body: { type, gameData, prompt }
      });

      if (error) throw error;
      return data.content;
    },
    onError: (error: any) => {
      toast.error(`Failed to generate content: ${error.message}`);
    },
  });

  const generateDescription = (gameData: any) => {
    return generateContentMutation.mutateAsync({ type: 'description', gameData });
  };

  const generateTags = (gameData: any) => {
    return generateContentMutation.mutateAsync({ type: 'tags', gameData });
  };

  const generateBlogPost = (gameData: any) => {
    return generateContentMutation.mutateAsync({ type: 'blog', gameData });
  };

  const generateCustomContent = (prompt: string) => {
    return generateContentMutation.mutateAsync({ type: 'custom', prompt });
  };

  return {
    generateDescription,
    generateTags,
    generateBlogPost,
    generateCustomContent,
    isLoading: generateContentMutation.isPending,
  };
};
